jQuery(document).ready(function($){
	// Reviews Slider
	$('.reviewsSlider').slick({
		infinite: true,
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1
	});
	// Homepage Slider
	$('.slideshow').slick({
		infinite: true,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev show-for-medium">Previous<span class="arrow"><svg width="28px" height="13px" viewBox="0 0 28 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g class="arrowFill" transform="translate(-516.000000, -471.000000)" stroke="#886957" stroke-width="2"><g transform="translate(530.000000, 478.000000) scale(-1, 1) translate(-530.000000, -478.000000) translate(506.000000, 454.000000)"><polyline id="Path-2" points="10.5 23.5 34.5 23.5 28 18 36 23.4890558 28 29"></polyline></g></g></g></svg></span></button>',
		nextArrow: '<button type="button" class="slick-next show-for-medium">Next<span class="arrow"><svg width="28px" height="13px" viewBox="0 0 28 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g class="arrowFill" transform="translate(-1296.000000, -471.000000)" stroke="#886957" stroke-width="2"><g transform="translate(1286.000000, 454.000000)"><polyline id="Path-2" points="10.5 23.5 34.5 23.5 28 18 36 23.4890558 28 29"></polyline></g></g></g></svg></span></button>',
		dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		autoplay: true,
		pauseOnHover: false
	});
	$('.donor-border:last').remove();

	var sessionStorage = window.sessionStorage;
	var localStorage = window.localStorage;

	if (!sessionStorage.getItem('accepted-cookie')) {
		sessionStorage.setItem('accepted-cookie', null);
	}

	if (JSON.parse(sessionStorage.getItem('accepted-cookie')) === null) {
		setTimeout(function () {
			$('#cookie-cutter').addClass('active');
		}, 2000);
	} else if (typeof (JSON.parse(sessionStorage.getItem('accepted-cookie'))) === 'boolean') {
		if (!JSON.parse(sessionStorage.getItem('accepted-cookie'))) {
			$(".cookie-watch").remove();
			localStorage.clear();
			var res = document.cookie;
			var multiple = res.split(";");
			for(var i = 0; i < multiple.length; i++) {
				var key = multiple[i].split("=");
				document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
			}
		} else {
			return;
		}
	}

	$('.decline-cookie').on('click', function (e) {
		e.preventDefault();
		$('.cookie-catcher').remove();
		$('#cookie-cutter').removeClass('active');
		sessionStorage.setItem('accepted-cookie', 'false');
		$(".cookie-watch").remove();
		localStorage.clear();
		var res = document.cookie;
		var multiple = res.split(";");
		for(var i = 0; i < multiple.length; i++) {
			var key = multiple[i].split("=");
			document.cookie = key[0]+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
		}
	})

	$('.close-cookie-cutter').on('click', function (e) {
		e.preventDefault();
		$('#cookie-cutter').removeClass('active');
		sessionStorage.setItem('accepted-cookie', 'true');
	});
});